"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterProjectWithoutPermissions = exports.filterProjectWithPermissions = exports.filterProjectWithCondition = void 0;
const contains_all_1 = require("./contains-all");
const roles_and_permissions_1 = require("./roles-and-permissions");
function filterProjectWithCondition(permissions, projects, filterCondition) {
    if (!permissions || !projects)
        return [];
    const projectIds = [];
    for (let i = 0; i < projects.length; i += 1) {
        const project = projects[i];
        const rolePermissions = roles_and_permissions_1.brioRolesPermissions[project.role];
        if (rolePermissions) {
            if (filterCondition(rolePermissions))
                projectIds.push(project.id);
        }
    }
    return projectIds;
}
exports.filterProjectWithCondition = filterProjectWithCondition;
function filterProjectWithPermissions(permissions, projects) {
    const filterCondition = (rolePermissions) => (0, contains_all_1.containsAll)(rolePermissions, permissions);
    return filterProjectWithCondition(permissions, projects, filterCondition);
}
exports.filterProjectWithPermissions = filterProjectWithPermissions;
function filterProjectWithoutPermissions(permissions, projects) {
    const filterCondition = (rolePermissions) => !(0, contains_all_1.containsAll)(rolePermissions, permissions);
    return filterProjectWithCondition(permissions, projects, filterCondition);
}
exports.filterProjectWithoutPermissions = filterProjectWithoutPermissions;
